import * as yup from 'yup'
import { REQUIRED_FIELD, ERROR_INVALID_PHONE_NUMBER } from './../constants'
import { parseNumber } from 'libphonenumber-js'
import isEmpty from 'lodash/isEmpty'

export default yup.object({
  firstname: yup.string().required(REQUIRED_FIELD),
  lastname: yup.string().required(REQUIRED_FIELD),
  email: yup.string().email(),
  unverifiedEmail: yup.string().email(),
  phone: yup.string().test('isValidPhoneNumber', ERROR_INVALID_PHONE_NUMBER, val => {
    if (val === undefined) return true
    if (val.length <= 3) return true
    return !isEmpty(parseNumber(val))
  }),
  unverifiedPhone: yup.string().test('isValidPhoneNumber', ERROR_INVALID_PHONE_NUMBER, val => {
    if (val === undefined) return true
    if (val.length <= 3) return true
    return !isEmpty(parseNumber(val))
  }),
})



// WEBPACK FOOTER //
// ./src/utils/validation/schemas/profileSchema.js